import React from 'react';
import { Reveal, Kicker } from './ui';
import { Odometer } from './Odometer';
const STATS = [{
  value: '128',
  suffix: '+',
  label: 'Projects shipped'
}, {
  value: '14',
  suffix: '',
  label: 'Client countries'
}, {
  value: '09',
  suffix: '',
  label: 'Years running'
}, {
  value: '87',
  suffix: '%',
  label: 'Clients who return'
}];
export function Manifesto() {
  return <section className="mx-auto max-w-[1400px] px-5 md:px-10 py-24 md:py-36" data-id="element-88">
      <Kicker ig="Ihe Anyị Kwenyere" en="What we believe" data-id="element-89" />

      <div className="mt-8 md:mt-12 font-display uppercase leading-[1.05] text-3xl md:text-6xl max-w-5xl" data-id="element-90">
        <Reveal data-id="element-91">Attention is cheap.</Reveal>
        <Reveal delay={120} data-id="element-92">
          Being remembered <span className="text-outline" data-id="element-93">is not.</span>
        </Reveal>
        <Reveal delay={240} data-id="element-94">
          We design for <span style={{
          color: 'var(--danfo)'
        }} data-id="element-95">the second one.</span>
        </Reveal>
      </div>

      <div className="mt-16 md:mt-24 grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-12" data-id="element-96">
        {STATS.map(s => <div key={s.label} className="border-t pt-6" style={{
        borderColor: 'var(--line)'
      }} data-id="element-97">
            <p className="font-display text-5xl md:text-7xl" data-id="element-98">
              <Odometer value={s.value} data-id="element-99" />
              {s.suffix && <span style={{
            color: 'var(--danfo)'
          }} data-id="element-100">{s.suffix}</span>}
            </p>
            <p className="font-monoui text-[11px] md:text-xs uppercase tracking-[0.18em] mt-3 opacity-50" data-id="element-101">
              {s.label}
            </p>
          </div>)}
      </div>
    </section>;
}